import {
  BookOpen,
  LayoutDashboard,
  Package,
  PartyPopper,
  Receipt,
  Sparkles,
  Warehouse,
} from 'lucide-react';
import type { TourStep } from './types';

/**
 * First-run tour shown on /dashboard. Targets live in the HeyGen dashboard
 * (hero + module cards) and the owner shell (rail, bottom tabs, AI trigger).
 * Steps whose target is absent (gated module, hidden FAB…) are auto-skipped
 * by the engine.
 */
export const DASHBOARD_TOUR_STEPS: TourStep[] = [
  {
    id: 'welcome',
    icon: PartyPopper,
    titleKey: 'welcome_title',
    descriptionKey: 'welcome_description',
  },
  {
    id: 'kpis',
    target: 'dashboard-hero',
    icon: LayoutDashboard,
    titleKey: 'kpis_title',
    descriptionKey: 'kpis_description',
  },
  {
    id: 'nav',
    target: 'sidebar',
    targetMobile: 'bottom-tabs',
    icon: LayoutDashboard,
    titleKey: 'nav_title',
    descriptionKey: 'nav_description',
  },
  {
    id: 'products',
    target: 'module-product',
    icon: Package,
    titleKey: 'products_title',
    descriptionKey: 'products_description',
    action: { labelKey: 'products_action', href: '/products/create' },
  },
  {
    id: 'pos',
    target: 'module-pos',
    icon: Receipt,
    titleKey: 'pos_title',
    descriptionKey: 'pos_description',
    action: { labelKey: 'pos_action', href: '/pos' },
  },
  {
    id: 'stock',
    target: 'module-stock',
    icon: Warehouse,
    titleKey: 'stock_title',
    descriptionKey: 'stock_description',
  },
  {
    id: 'copilot',
    target: 'ai-trigger',
    targetMobile: 'chat-fab',
    icon: Sparkles,
    titleKey: 'copilot_title',
    descriptionKey: 'copilot_description',
  },
  {
    id: 'help',
    target: 'rail-help',
    targetMobile: null,
    icon: BookOpen,
    titleKey: 'help_title',
    descriptionKey: 'help_description',
  },
];
